import React, { PureComponent } from 'react'
import cn from 'classnames'
import {
  Paper,
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  Divider,
  ExpansionPanelDetails,
  List,
  ListItem,
  ListSubheader,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  LinearProgress,
  ListItemIcon
} from '@material-ui/core'
import { ExpandMore, DepartureBoard } from '@material-ui/icons'

export class BlockingBase extends PureComponent {
  renderCity = ({ label, station, id, disabled, departureTime, arrivalTime }) => {
    const { classes, isDisabled, disableCity, isPartner, isLimitedDispatcher } = this.props

    const disable = isDisabled || disabled
    const time = departureTime || arrivalTime
    const switchDisabled = isDisabled
      || isPartner
      || isLimitedDispatcher

    return (
      <ListItem key={id} dense>

        <ListItemIcon className={cn(classes.placeIcon, disable && classes.disabled)}>
          <div className={classes.time}>
            <DepartureBoard />
            <Typography
              align='center'
              variant='caption'
            >
              {time}
            </Typography>
          </div>
        </ListItemIcon>

        <ListItemText
          primary={label}
          secondary={station}
          className={disable ? classes.disabled : null}
        />

        <ListItemSecondaryAction>
          <Switch
            value='disableCity'
            checked={disabled}
            disabled={switchDisabled}
            onChange={(e, checked) => disableCity({ id, checked })}
          />
        </ListItemSecondaryAction>

      </ListItem>
    )
  }

  renderCitiesList = () => {
    const { isLoading, classes, isDisabled, disableRoute, mainCities, isPartner, isLimitedDispatcher } = this.props

    return isLoading
      ? <LinearProgress className={classes.linearProgress} />
      : (
        <List>
          <ListItem>
            <ListItemText primary='Заблокувати рейс' />
            <ListItemSecondaryAction>
              <Switch
                value='disableRoute'
                checked={isDisabled}
                disabled={isPartner || isLimitedDispatcher}
                onChange={(e, checked) => disableRoute(checked)}
              />
            </ListItemSecondaryAction>
          </ListItem>
          <ListSubheader>Міста</ListSubheader>
          {mainCities.map(this.renderCity)}
        </List>
      )
  }

  render() {
    const { classes, routeId } = this.props

    return (
      <Paper>
        <ExpansionPanel defaultExpanded>

          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography>Блокування</Typography>
          </ExpansionPanelSummary>

          <Divider />

          <ExpansionPanelDetails className={classes.content}>
            {routeId
              ? this.renderCitiesList()
              : (
                <Typography
                  align='center'
                  variant='subtitle1'
                >
                  Оберіть будь ласка рейс
                </Typography>
              )}
          </ExpansionPanelDetails>

        </ExpansionPanel>
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Blocking/Blocking.js